import Http from '@/utils/http'
import { RequestType } from '@/typings/enum/Common'
import NLoginApi = global.NLoginApi

class BankApi extends Http {
  [x: string]: any

  // todo: 这种元数据的接口需要重新定义
  public async getAllBankNames(data: NLoginApi.MultiBankRequestData) {
    data.type = 'all'
    return await super.request<NLoginApi.MultiBankResponse>({
      url: '/crossbowSystem/getBankNames',
      method: RequestType.Post,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data
    })
  }
}

export default BankApi
